if (!customElements.get("td-md-product-buybox")) {
  class TdTabSelect extends HTMLElement {
    constructor() {
      super();
      this.selectElement = this.querySelector("#td-mp__frequency");
      this.priceElement = this.querySelector(".td-mp__price");
      this.quantitySelect = this.querySelector("#td-mp__quantity");
      this.strengthButtons = this.querySelectorAll(".td-mp__strength-btn")
    }

    connectedCallback() {
      if (this.selectElement) {
        this.selectElement.addEventListener("change", this.updatePrice.bind(this));
        this.updatePrice();
      }
      if (this.strengthButtons) {
        this.strengthButtons.forEach(button => {
          button.addEventListener("click", this.updateStrength.bind(this));
        });
      }
    }


    updateStrength(event) {
      this.strengthButtons.forEach(button => {
        button.classList.remove("active");
      });
      event.target.classList.add("active");
    }


    updatePrice() {
      const selectedOption = this.selectElement ? this.selectElement.options[this.selectElement.selectedIndex] : null;
      const price = selectedOption ? selectedOption.dataset.price : null;
      const quantities = selectedOption ? selectedOption.dataset.quantity : null;

      if (this.priceElement && price) {
        this.priceElement.textContent = price;
      }

      if (this.quantitySelect && quantities) {
        const quantityArray = quantities.split(" | ");
        this.quantitySelect.innerHTML = "";
        
        quantityArray.forEach(quantity => {
          const option = document.createElement("option");
          option.text = quantity;
          this.quantitySelect.add(option);
        });
      }
    }
  }
  customElements.define('td-md-product-buybox', TdTabSelect);
}
